var _title, _desc, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSelfService = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "21px",
    viewBox: "0 0 32 21",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "savitarna")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Uzsakymai",
    transform: "translate(-1105.000000, -175.000000)",
    fill: "#464648",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "savitarna",
    transform: "translate(1105.000000, 175.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0720929,13.9929661 L24.0088474,10.8107979 C23.9817575,10.7690169 23.9353509,10.7437983 23.8855561,10.7437983 L16.5233584,10.7437983 C16.4735636,10.7437983 16.427157,10.7690169 16.4000672,10.8107979 L14.3368216,13.9929661 C14.3097318,14.0347471 14.2633251,14.0599656 14.2135304,14.0599656 L13.9359195,14.0599656 C13.8547675,14.0599656 13.7889807,14.1257524 13.7889807,14.2069044 C13.7889807,14.2163274 13.7898872,14.2257286 13.7916875,14.234978 L14.8095504,19.4643978 C14.822987,19.5334302 14.8834545,19.583263 14.9537825,19.583263 L15.2215056,19.583263 C15.3026577,19.583263 15.3684444,19.6490497 15.3684444,19.7302017 L15.3684444,20.5417133 C15.3684444,20.6228653 15.4342311,20.6886521 15.5153832,20.6886521 L17.3716331,20.6886521 C17.4527852,20.6886521 17.5185719,20.6228653 17.5185719,20.5417133 L17.5185719,19.7302017 C17.5185719,19.6490497 17.5843586,19.583263 17.6655107,19.583263 L22.7434038,19.583263 C22.8245559,19.583263 22.8903426,19.6490497 22.8903426,19.7302017 L22.8903426,20.5417133 C22.8903426,20.6228653 22.9561293,20.6886521 23.0372814,20.6886521 L24.8935313,20.6886521 C24.9746834,20.6886521 25.0404701,20.6228653 25.0404701,20.5417133 L25.0404701,19.7302017 C25.0404701,19.6490497 25.1062568,19.583263 25.1874089,19.583263 L25.4551321,19.583263 C25.52546,19.583263 25.5859275,19.5334302 25.5993641,19.4643978 L26.617227,14.234978 C26.6327316,14.1553208 26.5807257,14.078177 26.5010686,14.0626724 C26.4918191,14.0608721 26.482418,14.0599656 26.472995,14.0599656 L26.1953841,14.0599656 C26.1455894,14.0599656 26.0991828,14.0347471 26.0720929,13.9929661 Z M16.4435081,17.9270034 C15.8509813,17.9270034 15.3684444,17.4308552 15.3684444,16.8216143 C15.3684444,16.2123734 15.8509813,15.7162252 16.4435081,15.7162252 C17.036035,15.7162252 17.5185719,16.2123734 17.5185719,16.8216143 C17.5185719,17.4308552 17.036035,17.9270034 16.4435081,17.9270034 Z M23.9654064,17.9270034 C23.3728795,17.9270034 22.8903426,17.4308552 22.8903426,16.8216143 C22.8903426,16.2123734 23.3728795,15.7162252 23.9654064,15.7162252 C24.5579333,15.7162252 25.0404701,16.2123734 25.0404701,16.8216143 C25.0404701,17.4308552 24.5579333,17.9270034 23.9654064,17.9270034 Z M15.3684444,14.6108361 L16.979266,11.8491874 L23.4261005,11.8491874 L25.0369221,14.6108361 L15.3684444,14.6108361 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46235725,17.0733366 C1.86273423,17.0733366 1.26665927,16.9894291 0.688324648,16.8179662 L0.017740326,16.6027254 L0.393835237,15.9934845 C1.33407251,14.4466694 6.15234505,6.87311241 8.90919171,6.87311241 C9.55139151,6.82203833 10.1829471,7.04822356 10.6548398,7.49694587 C10.9173966,7.77055703 11.0628673,8.14266821 11.0593826,8.52937199 L9.9807074,8.52937199 C9.9807074,8.27035342 9.69686218,7.97850151 8.90564364,7.97850151 C7.94766604,7.97850151 6.27297927,9.69677962 4.60893669,11.7908171 C5.41079942,13.8666137 5.41434749,15.3660128 4.60893669,16.2561512 C4.03415013,16.8252625 3.25712385,17.1207625 2.46235725,17.0733366 Z M1.71016742,15.9022808 C2.43042466,16.0117253 3.3848542,16.0226697 3.86029493,15.5082807 C4.3321876,14.9938917 4.27541856,14.1110397 3.86029493,12.8122987 C3.07972059,13.8520211 2.34527109,14.9318732 1.72081162,15.8986326 L1.71016742,15.8986326 L1.71016742,15.9022808 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36223528,16.6720402 C6.80164098,16.102929 6.68810289,15.2164288 7.08903426,14.5159842 C6.68810289,14.3481694 6.36522896,14.0234841 6.19137377,13.6148915 L6.19137377,20.6850039 L7.80219537,20.6850039 L7.80219537,16.985781 C7.64253243,16.9055217 7.49351369,16.7997254 7.36223528,16.6720402 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9126938,0.246366336 L26.1759723,1.80998879 C26.1085122,1.8707251 26.0209535,1.90433369 25.9301804,1.90433369 L10.0933255,1.90433369 C10.0025524,1.90433369 9.91499368,1.8707251 9.84753362,1.80998879 L8.11081211,0.246366336 C7.96137713,0.111825544 7.7315433,0.122430428 7.59513273,0.270160569 L4.28096091,3.85934781 C4.14852712,4.00277118 4.15140272,4.22472749 4.28750773,4.36467175 L5.96784566,6.09240856 C6.57101674,5.95013076 7.18838009,5.86257519 7.80574343,5.8260937 L7.80574343,5.22050099 L6.54375114,4.35639127 C6.37635237,4.2417702 6.33356758,4.01314794 6.44818866,3.84574917 C6.45857508,3.83058028 6.47008555,3.81621247 6.48262304,3.80276687 L7.56032341,2.64700656 C7.69868295,2.49862537 7.93113224,2.49050122 8.07951343,2.62886076 C8.08974394,2.6384003 8.09942122,2.6485164 8.10849799,2.65915964 L8.76726411,3.43161536 C8.83705791,3.51345414 8.93921261,3.56059327 9.04677078,3.56059327 L26.9731871,3.56059327 C27.0807453,3.56059327 27.1829,3.51345414 27.2526938,3.43161536 L27.9114599,2.65915964 C28.0431075,2.50479237 28.2749683,2.48637442 28.4293356,2.618022 C28.4399788,2.62709877 28.4500949,2.63677605 28.4596345,2.64700656 L29.5376369,3.8030908 C29.6759964,3.951472 29.6678723,4.18392128 29.5194911,4.32228082 C29.5061375,4.33473251 29.4918742,4.3461713 29.4768197,4.3565021 L28.3772587,5.11105038 C28.2774257,5.17955852 28.2177625,5.29286105 28.2177625,5.41393957 L28.2177625,20.6886521 L29.8285841,20.6886521 L29.8285841,6.47506613 C29.8285841,6.37940872 29.8658976,6.2875241 29.9325904,6.21894999 L31.7359982,4.36467175 C31.8721032,4.22472749 31.8749788,4.00277118 31.742545,3.85934781 L28.4283732,0.270160569 C28.2919626,0.122430428 28.0621288,0.111825544 27.9126938,0.246366336 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 12.2124404,
    cy: 9.11672395,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.7345604,
    cy: 10.6817798,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.6903204,
    cy: 10.6817798,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 11.8327974,
    cy: 12.6335394,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 9.17174853,
    cy: 12.2468357,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 9.93103448,
    cy: 14.5889472,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 11.0770595,
    cy: 16.544355,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.7345604,
    cy: 7.5589644,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 15.2531323,
    cy: 5.99755669,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 15.6363233,
    cy: 8.73002017,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 17.5309901,
    cy: 6.77826054,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.8123961,
    cy: 7.5589644,
    rx: 1,
    ry: 1
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSelfService, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/self-service.973ce421.svg";
export { ForwardRef as ReactComponent };